import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { captureResetToken } from './app/helpers/reset-token.util';
import { loadPendo } from './app/helpers/pendo-loader.util';

// Take a set-password link's token out of the address bar before anything else
// runs, including the APP_INITIALIZER that loads Google Maps.
captureResetToken();
// Pendo loads only once the token is out of the address bar, so its agent cannot read it there.
loadPendo();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
